import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import AuthProvider from './components/AuthProvider';
import { DevAuthProvider } from './components/DevAuthProvider';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout/Layout';
import Dashboard from './components/Dashboard/Dashboard';
import AssessmentsList from './components/Assessments/AssessmentsList';
import LaceToolFormModern from './components/LaceToolForm/LaceToolFormModern';
import AuditLogs from './components/AuditLogs/AuditLogs';
import UserProfile from './components/UserProfile';
import FacilityManagement from './components/Facilities/FacilityManagement';
import FacilityStats from './components/Facilities/FacilityStats';
import FacilityImport from './components/Facilities/FacilityImport';
import Reports from './components/Reports/Reports';
import SessionExpiredListener from './components/SessionExpiredListener';
import { DEV_MODE } from './authConfig';

const AppContent: React.FC = () => {
  return (
    <Router>
      <ProtectedRoute>
        <Routes>
          <Route path="/" element={<Layout title="Dashboard"><Dashboard /></Layout>} />
          <Route path="/assessments" element={<Layout title="Assessments"><AssessmentsList /></Layout>} />
          <Route path="/assessments/new" element={<Layout title="New Assessment"><LaceToolFormModern /></Layout>} />
          <Route path="/assessments/edit/:id" element={<Layout title="Edit Assessment"><LaceToolFormModern /></Layout>} />
          <Route path="/facilities" element={<Layout title="Facilities"><FacilityManagement /></Layout>} />
          <Route path="/facilities/stats" element={<Layout title="Facility Statistics"><FacilityStats /></Layout>} />
          <Route path="/facilities/import" element={<Layout title="Import Facilities"><FacilityImport /></Layout>} />
          <Route path="/reports" element={<Layout title="Reports"><Reports /></Layout>} />
          <Route path="/audit-logs" element={<Layout title="Audit Logs"><AuditLogs /></Layout>} />
          <Route path="/profile" element={<Layout title="User Profile"><UserProfile /></Layout>} />
        </Routes>
        <SessionExpiredListener />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              duration: 3000,
              iconTheme: {
                primary: '#4ade80',
                secondary: '#fff',
              },
            },
            error: {
              duration: 5000,
              iconTheme: {
                primary: '#ef4444',
                secondary: '#fff',
              },
            },
          }}
        />
      </ProtectedRoute>
    </Router>
  );
};

const App: React.FC = () => {
  if (DEV_MODE) {
    return (
      <DevAuthProvider>
        <AppContent />
      </DevAuthProvider>
    );
  }

  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
};

export default App;
